
import React from 'react';

import NonFSIndex from "@dndComponents/NonFSIndex";

export default function GameCardIndex() {
  return (
    <NonFSIndex
      data_type="game_card"
    />
  );
}
